import type { ITimelinePeriod } from '@features/timeline/types';

import { TIMELINE_MODE } from '@features/timeline/constants';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);

export const getPeriodByTimelineMode = (
  mode: TIMELINE_MODE,
  timezone: string
): ITimelinePeriod => {
  const now = dayjs().tz(timezone);

  switch (mode) {
    case TIMELINE_MODE.DAY: {
      return {
        end: now.endOf('day').valueOf(),
        start: now.startOf('day').valueOf(),
      };
    }
    case TIMELINE_MODE.WEEK: {
      return {
        end: now.endOf('isoWeek').valueOf(),
        start: now.startOf('isoWeek').valueOf(),
      };
    }
    case TIMELINE_MODE.MONTH: {
      return {
        end: now.endOf('month').valueOf(),
        start: now.startOf('month').valueOf(),
      };
    }
    default: {
      const timestamp = now.valueOf();

      return {
        end: timestamp,
        start: timestamp,
      };
    }
  }
};
